module.exports = __webpack_public_path__ + "site/img/moneyen.611254ec.png";